export default "__VITE_ASSET__DeLPWLze__"